
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAll_late_Report = createAsyncThunk(
    'report/fetchAll_late_report',
    async ( {StartDate , EndDate} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/late_details?StartDate=${StartDate}&EndDate=${EndDate}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all late Report');
        }
    }
);
export const fetchAll_late_count = createAsyncThunk(
    'report/fetchAll_late_report_count',
    async ( {StartDate , EndDate} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/late/count?StartDate=${StartDate}&EndDate=${EndDate}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all late Report');
        }
    }
);
export const fetch_All_Late_count_monthly = createAsyncThunk(
    'report/fetchAll_late_report_count_monthly',
    async ( {StartDate , EndDate} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/late/count/monthly?StartDate=${StartDate}&EndDate=${EndDate}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all late Report');
        }
    }
);